export default {
    type: 'podcast-modules',
    aliases: {
        camel: 'podcastModules',
        singular: 'Podcast module',
        plural: 'Podcast modules',
        lowerSingular: 'podcast module',
        lowerPlural: 'podcast modules',
    },
    publishable: false,
    adminSection: null,
    componentType: 'pivot',
    components: {}
};
